<template>
  <div><v-dialog v-model="hideShow" max-width="560" persistent scrollable><v-card class="edu-record-dialog">
    <v-card-title>拒绝请假<v-spacer /><v-btn icon aria-label="关闭拒绝请假" @click="cancel"><v-icon>mdi-close</v-icon></v-btn></v-card-title>
    <v-card-text v-if="absenceViewModel">
      <div class="edu-record-detail-grid"><div><label>请假学员</label><strong>{{absenceViewModel.studentName}}</strong></div><div><label>课程</label>{{absenceViewModel.courseName}}</div><div class="edu-record-detail-wide"><label>班级</label>{{absenceViewModel.className}}</div><div class="edu-record-detail-wide"><label>上课时间</label>{{absenceViewModel.classDate}} {{absenceViewModel.timeFrom}}–{{absenceViewModel.timeTo}}</div></div>
      <v-textarea label="拒绝原因" aria-label="拒绝原因" v-model="update.refuseReason" outlined rows="3" hide-details color="#d9363e" />
    </v-card-text>
    <v-card-actions><v-spacer /><v-btn text @click="cancel">取消</v-btn><v-btn depressed color="#d9363e" dark @click="submitUpdate" :disabled="update.submitting" :loading="update.submitting">确定</v-btn></v-card-actions>
  </v-card></v-dialog></div>
</template>

<script>
	import utils from "../config/utils"
	export default {
		name:"refuse-absence",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			absenceModel:{
				type:Object,
				default:null
			}
			
		},
		watch:{
			show(newVal,oldVal){
			
				this.hideShow = newVal;
				if(this.hideShow){
					this.absenceViewModel = this.absenceModel;
				}
			}
		},
		data(){
			return {
				shopId:"",
				hideShow:this.show,
				absenceViewModel:null,
				update:{
					submitting:false,
					refuseReason:"",
				}
			}
		},
		mounted() {
			console.log("refuse absence mounted");
			this.shopId = utils.getCurrentShopId();
		},
		methods:{
			cancel(){
				this.$emit("cancel","");
			},
			submitUpdate(){
				if(!this.update.refuseReason){
					this.$noty.error("请输入拒绝原因");
					return
				}
				this.update.submitting = true;
				
				let postData = {
					absenceId:this.absenceModel.id,
					refuseReason:this.update.refuseReason,
				}
				// api
				const that = this;
				const shopId = this.shopId || utils.getCurrentShopId();
				let url = `/edu/absence/refuse`;
				if (shopId) {
					url += `?shopId=${shopId}`;
				}
					
				this.axios.post(url, postData).catch(() => {
					that.update.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							
							that.update.submitting = false;
							that.$emit("success","");
							return;
						} else {
							that.update.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.update.submitting = false;
						that.$noty.error('网络请求失败');
					}
							
				});
				
				
				
			},
			
			
			
		}
	}
	
</script>
<style scoped lang="scss">
@import "../assets/styles/edu-records.scss";
</style>
